import { PrivacyPolicy, TermsOfServiceCombined, TermsOfService } from '@anytag/app';
import { PartialRouter } from '../../types';

export const TermsPrivacyPolicyRouter = {
  '/_public-routes/privacy': [PrivacyPolicy, {}],
  '/_public-routes/terms-combined': [TermsOfServiceCombined, {}],
  '/_public-routes/terms': [TermsOfService, {}]
} as const satisfies PartialRouter;
